import React from "react";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import { StyledTab } from "../../component/Methods";

const PortfolioTabs = ({ 
  value, 
  onChange, 
  onPositionPerformanceClick 
}) => {
  return (
    <Tabs
      value={value}
      onChange={onChange}
      allowScrollButtonsMobile
      aria-label="scrollable force tabs example"
      sx={{
        [`& .${tabsClasses.scrollButtons}`]: {
          "&.Mui-disabled": { opacity: 0.3 },
          borderRadius: "50%",
          background: "#808080",
          height: "20px",
          width: "20px",
          mt: 2,
        },
      }}
      indicatorColor="white"
      textColor="inherit"
    >
      {/* Uncomment when needed */}
      {/* <StyledTab
        onClick={onPositionPerformanceClick}
        label="Positions Performance"
      /> */}
    </Tabs>
  );
};

export default PortfolioTabs;
